module.exports = __webpack_public_path__ + "media/src/application/media/v2-icon-1-7fdf29faa566a1789830b47d2dca9996.svg";